import { addModal } from 'weblite-web-modal-viewer'
import { UserActiveSessionsLimitModal } from './user-active-sessions-limit'

const COMPONENT_ID = 'userActiveSessionsLimit'

interface Props {
  onRegister: () => unknown
  onCancel: () => unknown
}

export const showUserActiveSessionsLimit = (props: Props) =>
  addModal({ id: COMPONENT_ID, props })

/**
 * Displays the User Active Sessions Limit Modal.
 *
 * @param {Props} props - The properties for the modal.
 * @param {() => unknown} props.onCancel - Callback when the cancel action is triggered.
 * @param {() => unknown} props.onRegister - Callback when the register action is triggered.
 * @returns {Promise<boolean>} - Resolves to true if we should continue loading the room, false otherwise.
 */
export const showUserActiveSessionsLimitModal = ({
  onCancel,
  onRegister,
}: Props): Promise<boolean> =>
  new Promise(resolve =>
    showUserActiveSessionsLimit({
      onCancel: () => {
        onCancel()
        resolve(false)
      },
      onRegister: () => {
        onRegister()
        resolve(true)
      },
    }),
  )

export default {
  [COMPONENT_ID]: {
    Component: UserActiveSessionsLimitModal,
  },
}
